module.exports = __webpack_public_path__ + "static/media/TL-ResponsiveMockup-nomerge.4bf84698.png";